import { createContext, useContext, useState } from "react";

const ThemeCtx = createContext({ theme: "system", setTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => localStorage.getItem("theme") || "light");
  const setTheme = (t) => {
    try { localStorage.setItem("theme", t); } catch (e) { console.error("Theme persist failed", e); }
    setThemeState(t);
  };
  return <ThemeCtx.Provider value={{ theme, setTheme }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
